import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=8a8a1fa0&scoped=true&"
import script from "./FloatingButton.vue?vue&type=script&lang=js&"
export * from "./FloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=8a8a1fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8a1fa0",
  null
  
)

export default component.exports